import { Table, Tabs } from "antd";
import styled from "styled-components";

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;

  background: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "rgba(246, 255, 237, 1)";
      case "delayed":
        return "rgba(255, 241, 240, 1)";
      default:
        return "rgba(0, 0, 0, 0.02)";
    }
  }};

  color: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "rgba(82, 196, 26, 1)";
      case "delayed":
        return "rgba(245, 34, 45, 1)";
      default:
        return "rgba(0, 0, 0, 0.88)";
    }
  }};

  border: ${(props) => {
    switch (props.variant) {
      case "concluded":
        return "1px solid rgba(183, 235, 143, 1)";
      case "delayed":
        return "1px solid rgba(255, 163, 158, 1)";
      default:
        return "1px solid rgba(228, 228, 231, 1)";
    }
  }};
`;

export const DescriptionText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;

  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const StyledTabs = styled(Tabs)`
  width: 100%;
  min-width: 0;

  .ant-tabs-nav {
    width: 100%;
  }

  .ant-tabs-content-holder {
    width: 100%;
    min-width: 0;
  }

  .ant-tabs-content {
    width: 100%;
  }

  .ant-tabs-tabpane {
    width: 100%;
  }

  .ant-tabs-ink-bar {
    background-color: rgba(17, 167, 217, 1) !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: rgba(17, 167, 217, 1) !important;
    font-weight: 400;
  }

  .ant-tabs-tab:hover {
    color: rgba(17, 167, 217, 1) !important;
  }

  &::before {
    border-bottom: 1px solid #f0f0f0;
  }
`;

export const StyledTable = styled(Table)`
  width: 100%;
  min-width: 0;

  .ant-table {
    width: 100%;
    min-width: 0;
  }

  .ant-table-container {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .ant-table-cell {
    min-width: 0;
    overflow: hidden;
  }

  .row-completed > td {
    background-color: rgba(217, 247, 190, 1) !important;
    transition: background-color 0.2s ease;
  }

  .ant-table-thead > tr > th {
    font-weight: 700 !important;
  }

  .row-completed:hover > td {
    background-color: rgba(217, 247, 190, 0.85) !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: rgb(82, 196, 37) !important;
    border-color: rgb(82, 196, 37) !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: rgb(82, 196, 37) !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: rgb(82, 196, 37) !important;
  }
`;
